import { Store } from 'redux';
import { NotFoundError } from '@cian/peperrors/shared';
import { getConfig } from '@cian/config/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';
import { getTelemetry } from '@cian/telemetry/browser';

import { IState, IContext } from '../../../shared/store';
import { createMakeRequest } from '../../../shared/utils/make_request';
import { createBookingContext } from '../pikBooking';
import { createRenderCallback, getOfferCardPage, renderReactApp } from './internal';

export function renderApp(store: Store<IState>) {
  const config = getConfig();
  const httpApi = getHttpApi();

  const rootElement = document.getElementById('frontend-offer-card');

  if (!rootElement) {
    throw new NotFoundError({
      message: 'Unable to find element #frontend-offer-card',
      domain: 'services#renderApp',
    });
  }

  const { pageData } = store.getState();

  const context: IContext = {
    config,
    httpApi,
    logger: getLogger(),
    makeRequest: createMakeRequest(httpApi),
    pikBookingContext: createBookingContext(),
    telemetry: getTelemetry(),
  };

  const offerCardPage = getOfferCardPage(pageData.offerType, context);

  renderReactApp({
    cb: createRenderCallback(store),
    store,
    offerCardPage,
    rootElement,
    context,
  });
}
